import RoomIcon from '@mui/icons-material/Room';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import makeStyles from '@mui/styles/makeStyles';
import { InfoWindow, Marker } from '@react-google-maps/api';
import format from 'date-fns/format';
import React from 'react';
import HotspotIcon from '../../assets/hotspot.svg';
import { DisplayMarkup } from '../../components/display-markup';
import { HotspotData } from '../../types';

const useStyles = makeStyles({
  link: {
    position: 'absolute',
    top: 15,
    left: 8,
    display: 'flex',
    alignItems: 'center',
    color: '#2979ff',
    textDecorationLine: 'none',
    borderRadius: 6,
    transition: 'all 0.2s',
    '&:hover': {
      color: '#2a2a2a',
      backgroundColor: '#2979ff11',
    },
  },
});

export function MapHotspot(props: { meetings: HotspotData[] }) {
  // Props
  const { meetings } = props;
  // State
  const [open, setOpen] = React.useState(false);
  // Hooks
  const classes = useStyles();

  const lat = meetings[0].Latitude;
  const lng = meetings[0].Longitude;

  // Googles Maps URL with address query
  const mapsURL = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

  if (lat && lng) {
    return (
      <Marker
        position={{ lat: lat, lng: lng }}
        icon={HotspotIcon}
        onClick={() => setOpen((currentState) => !currentState)}
      >
        {open && (
          <InfoWindow
            position={{ lat: lat, lng: lng }}
            onCloseClick={() => setOpen(false)}
          >
            <Box>
              <Box
                component="a"
                href={mapsURL}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
              >
                <RoomIcon fontSize="small" />

                <strong style={{ marginLeft: 3 }}>Open in Google Maps</strong>
              </Box>
              <Stack spacing={1}>
                <Stack spacing={1} direction="row" alignItems="center">
                  <Box sx={{ flex: 1, borderTop: '1px solid #eaeaea' }} />
                  <Box sx={{ fontFamily: 'Oswald', fontSize: 18 }}>
                    Hotspot Meeting
                  </Box>
                  <Box sx={{ flex: 1, borderTop: '1px solid #eaeaea' }} />
                </Stack>

                {meetings.map((m) => {
                  return (
                    <React.Fragment key={m.MeetingId}>
                      {m.DateTime ? (
                        <Box
                          sx={{ fontWeight: 'bold', fontSize: 16, pt: '5px' }}
                        >
                          {format(
                            new Date(m.DateTime),
                            "EEEE, MMMM do 'at' pp",
                          )}
                        </Box>
                      ) : null}

                      <Stack spacing={1} direction="row" alignItems="center">
                        {m.HostImage ? (
                          <Box
                            sx={{
                              height: 64,
                              width: 64,
                              borderRadius: 2,
                              backgroundImage: `url(${m.HostImage})`,
                              backgroundPosition: 'center',
                              backgroundRepeat: 'no-repeat',
                              backgroundSize: 'cover',
                            }}
                          />
                        ) : null}

                        <Box>
                          <Box sx={{ fontWeight: 'bold', fontSize: 20 }}>
                            {m.HostName}
                          </Box>
                          <Box sx={{ fontSize: 18 }}>at {m.Location}</Box>
                        </Box>
                      </Stack>

                      <Box sx={{ maxWidth: 320 }}>
                        <DisplayMarkup markup={m.Description} />
                      </Box>

                      <Divider />
                    </React.Fragment>
                  );
                })}
              </Stack>
            </Box>
          </InfoWindow>
        )}
      </Marker>
    );
  } else {
    return null;
  }
}
